import { QueryClient } from "@tanstack/react-query";

export const handleSocket = (
    event: MessageEvent,
    websocket: WebSocket,
    userQuery: any,
    unreadedMessages: any,
    queryClient: QueryClient
) => {
    const data = JSON.parse(event.data);
    const teamInfo = unreadedMessages?.teamInfo || [];
    let teamIndex = teamInfo.findIndex((team: any) => team.teamId === data.d.teamId);

    let chatId = window.location.pathname.split("/")[2];
    let channelId = window.location.pathname.split("/")[4];
    const sendNotification = (title: string, body: string, icon: string, link: string) => {
        if (Notification.permission === "granted") {
            new Notification(title, {
                body: "Teamly | " + body,
                icon: icon
            }).onclick = () => {
                window.focus();
                window.location.href = link;
            };
        }
    };

    switch (data.t) {
        case "MESSAGE_SEND":
            if ((data.d.channelType === "text" || data.d.channelType == "dm") && (channelId || chatId) !== data.d.channelId) {
                if (data.d.message.createdBy.id !== userQuery.data?.user.id && userQuery.data?.user?.presence !== 3) {
                    sendNotification(data.d.message.createdBy.username, data.d.message.content, data.d.message.createdBy.avatar, `/teams/${data.d.teamId}/channels/${data.d.channelId}`);
                }
            if (data.d.channelType == "dm") {
                const find = unreadedMessages?.dmInfo?.[data.d.channelId];
                if (find) {
                find.unread += 1;
                find.lastRead = new Date().toISOString();
                } else {
                if (data.d.message.createdBy.id == userQuery.data?.user.id) return;
                queryClient.setQueryData(["unread"], (oldData: any) => {
                    return { ...oldData, dmInfo: { ...oldData.dmInfo, [data.d.channelId]: { unread: 1, lastRead: new Date().toISOString(), data: { participants: [data.d.message.createdBy] } } } };
                });
                }
            }
            if (teamIndex === -1) {
                teamInfo.push({ teamId: data.d.teamId, channelInfo: {}, badgingInfo: {} });
                teamIndex = teamInfo.length - 1;
            }
            const team = teamInfo[teamIndex];
            team.channelInfo = team.channelInfo || {};
            team.channelInfo[data.d.channelId] = { unread: (team.channelInfo[data.d.channelId]?.unread || 0) + 1, lastRead: new Date().toISOString(), data: data.d };
            queryClient.setQueryData(["unread"], (oldData: any) => {
                return { ...oldData, teamInfo: [...teamInfo] };
            });
            } else {
                const getAllData = queryClient.getQueryData(["messages", data.d.channelId]) as any;
                const messages = getAllData?.pages.flatMap((page: any) => page.messages) || [];
                let updatedMessages;
                const nonceMessage = messages.find((message: any) => {
                    return message.nonce === data.d.message.nonce && message.state === "sending"
                });
                if (nonceMessage) {
                    const updatedNonceMessage = { ...nonceMessage, ...data.d.message, state: undefined };
                    updatedMessages = messages.map((message: any) => {
                        if (message.nonce === nonceMessage.nonce) {
                            return updatedNonceMessage;
                        }
                        return message;
                    });
                } else {
                    updatedMessages = [...messages, data.d.message];
                }

                queryClient.setQueryData(["messages", data.d.channelId], () => ({
                    pages: [
                        {
                            messages: updatedMessages
                        }
                    ],
                    pageParams: [0],
                    hasNextPage: false
                }));
            }
            break;
        case "CHANNEL_MOUNTED":
            const teamId = window.location.pathname.split("/")?.[2] || "";
            const team = teamInfo.find((team: any) => team.teamId === teamId);
            if (team) {
                delete team.channelInfo[data.d.channelId];
                delete team.badgingInfo?.[data.d.channelId];
            }
            const dmIndex = unreadedMessages?.dmInfo?.[data.d.channelId];
            if (dmIndex) {
                dmIndex.unread = 0;
                dmIndex.lastRead = new Date().toISOString();
            }
            queryClient.setQueryData(["unread"], (oldData: any) => {
                const updatedTeamInfo = oldData?.teamInfo?.filter((team: any) => team.teamId !== data.d.teamId) || [];
                return { ...oldData, teamInfo: [...updatedTeamInfo, ...teamInfo] };
            });
            break;
        case "USER_MENTIONED":
            if (data.d.channelId !== (window.location.pathname.split("/")?.[4] || "")) {
                if (teamIndex === -1) {
                    teamInfo.push({ teamId: data.d.teamId, channelInfo: {}, badgingInfo: {} });
                    teamIndex = teamInfo.length - 1;
                }
                const team = teamInfo[teamIndex];
                team.badgingInfo = team.badgingInfo || {};
                team.channelInfo = team.channelInfo || {};
                team.badgingInfo[data.d.channelId] = { unread: (team.badgingInfo[data.d.channelId]?.unread || 0) + 1, lastRead: new Date().toISOString(), data: data.d };
                queryClient.setQueryData(["unread"], (oldData: any) => {
                    oldData = oldData?.teamInfo?.filter((team: any) => team.teamId !== data.d.teamId);
                    return { ...oldData, teamInfo: [...teamInfo] };
                });
            }
            break;
        case "EMAIL_CHANGED":
            userQuery.refetch();
            break;
        case "FRIEND_REQUEST":
            const friendRequest = data.d.friend;
            const user = userQuery.data?.user;
            if (friendRequest.status == "pending" && friendRequest.users.find((u: any) => u.id == user!.id)) {
                queryClient.setQueryData(["user"], (oldData: any) => {
                    return {
                        ...oldData,
                        friends: [...oldData.friends, friendRequest]
                    };
                });
            }
            break;
        case "FRIEND_REQUEST_ACCEPTED":
            const acceptedFriendRequest = data.d.friend;
            const acceptedUser = userQuery.data?.user;
            if (acceptedFriendRequest.status === "accepted" && acceptedFriendRequest.users.find((u: any) => u.id === acceptedUser!.id)) {
                queryClient.setQueryData(["user"], (oldData: any) => {
                    const updatedFriends = oldData.friends.filter((friend: any) => {
                        const existingUsers = friend.users.map((f: any) => f.id).sort().join(",");
                        const newUsers = acceptedFriendRequest.users.map((u: any) => u.id).sort().join(",");
                        return existingUsers !== newUsers;
                    });
                    return {
                        ...oldData,
                        friends: [...updatedFriends, acceptedFriendRequest],
                    };
                });
            }
            break;
        case "FRIEND_REQUEST_REJECTED":
            const rejectedFriendRequest = data.d.friend;
            const rejectedUser = userQuery.data?.user;
            if (rejectedFriendRequest.users.find((u: any) => u === rejectedUser!.id)) {
                queryClient.setQueryData(["user"], (oldData: any) => {
                    const updatedFriends = oldData.friends.filter((friend: any) => {
                        return friend.users.map((f: any) => f.id).sort().join(",") !== rejectedFriendRequest.users.sort().join(",");
                    });
                    return {
                        ...oldData,
                        friends: updatedFriends,
                    };
                });
            }
            break;
        case "MESSAGE_DELETED":
            const getAllDataDeleted = queryClient.getQueryData(["messages", data.d.channelId]) as any;
            let findMessage = getAllDataDeleted?.pages[0].messages.find((message: any) => message.id === data.d.messageId);
            if (findMessage) {
                const updatedMessagesDeleted = getAllDataDeleted?.pages[0].messages.map((message: any) => {
                    if (message.id === data.d.messageId) {
                        return {
                            ...message,
                            state: "deleted",
                            content: "This message has been deleted",
                            createdBy: {},
                            attachments: [],
                            embeds: []
                        }
                    }
                    return message;
                });

                queryClient.setQueryData(["messages", data.d.channelId], () => {
                    return {
                        pages: [
                            {
                                messages: updatedMessagesDeleted
                            }
                        ],
                        pageParams: [0],
                        hasNextPage: false
                    };
                });
            }
            break;
        case "MESSAGE_UPDATED":
            const getAllDataUpdated = queryClient.getQueryData(["messages", data.d.channelId]) as any;
            const messagesUpdated = getAllDataUpdated?.pages[0].messages;
            const updatedMessagesUpdated = messagesUpdated.map((message: any) => {
                if (message.id === data.d.message.id) {
                    return data.d.message;
                }
                return message;
            });
            queryClient.setQueryData(["messages", data.d.channelId], () => {
                return {
                    pages: [
                        {
                            messages: updatedMessagesUpdated
                        }
                    ],
                    pageParams: [0],
                    hasNextPage: false
                };
            });
            break;
        case "PRESENCE_UPDATE":
            const allTeamsMembers = queryClient.getQueriesData({
                predicate: (query) => query.queryKey[0] === "team" && query.queryKey[2] === "members"
            });

            allTeamsMembers.forEach((team: any, i: number) => {
                if (!team[i][1]) return;
                queryClient.setQueryData(["team", team[i][1], "members"], () => {
                    let members = queryClient.getQueryData(["team", team[i][1], "members"]) as any;
                    members = members.members.map((member: any) => {
                        if (member.id === data.d.userId) {
                            return { ...member, presence: data.d.presence };
                        }
                        return member;
                    });
                    return { members };
                });
            });
            break;
        case "USER_PROFILE_UPDATED":
            if (data.d.user.id === userQuery.data?.user.id) {
                queryClient.setQueryData(["user"], (oldData: any) => {
                    return { ...oldData, user: { ...oldData.user, ...data.d.user } };
                });
            }

            const allTeamsMembersProfile = queryClient.getQueriesData({
                predicate: (query) => query.queryKey[0] === "team" && query.queryKey[2] === "members"
            });

            allTeamsMembersProfile.forEach((team: any, i: number) => {
                if (!team[i][1]) return;
                queryClient.setQueryData(["team", team[i][1], "members"], () => {
                    let members = queryClient.getQueryData(["team", team[i][1], "members"]) as any;
                    members = members.members.map((member: any) => {
                        if (member.id === data.d.user.id) {
                            return { ...member, ...data.d.user };
                        }
                        return member;
                    });
                    return { members };
                });
            });
            break;
        case "USER_ROLE_REMOVED":
        case "USER_ROLE_ADDED":
            queryClient.setQueryData(["team", data.d.teamId, "members"], () => {
                let getData = queryClient.getQueryData(["team", data.d.teamId, "members"]) as any;
                return {
                    members: getData.members.map((member: any) => {
                        return member.id === data.d.member.id
                            ? {
                                ...member,
                                roles: data.t === "USER_ROLE_REMOVED"
                                    ? member.roles.filter((role: any) => role != data.d.role.id)
                                    : [...member.roles, data.d.role.id]
                            }
                            : member
                    })
                };

            });
            break;
        case "TEAM_ROLES_UPDATED":
            queryClient.setQueryData(["team", data.d.teamId, "roles"], { roles: data.d.roles });
            break;
        case "TEAM_ROLE_CREATED":
            queryClient.setQueryData(["team", data.d.teamId, "roles"], { roles: [...(data.d.roles || []), data.d.role] });
            break;

        case "TEAM_ROLE_DELETED":
            queryClient.setQueryData(["team", data.d.teamId, "roles"], { roles: data.d.roles.filter((role: any) => role.id !== data.d.roleId) });
            break;

        default:
            break;
    }
};
